import axios from 'axios';
import Config from '../../commons/config/Config.js';
import swal from 'sweetalert2';
import backendStrings from '../../lang/backendStrings.js';
// import { useIntl, FormattedMessage } from 'react-intl'

// Se pasa un service o modulo. E.G.: "/moviles" "/moviles/2"
export const getData = (service) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'GET',
      url: Config.get('apiUrlBase') + service,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization-Token': localStorage.getItem('token'),
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => {
        handleError(err)
          reject(err);
      });
  });
};

// Se pasa un service o modulo como String. E.G.: "/moviles" "/moviles/2"
// Se suma un metodo como String. E.G.: "POST" "PUT"
export const sendData = (service, method, data) => {
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: Config.get('apiUrlBase') + service,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization-Token': localStorage.getItem('token'),
      },
      data: data,
    })
      .then((res) => resolve(res.data))
      .catch((err) => {
        handleError(err);
        reject(err);
      });
  });
};

export const dataBlob = (service, method, data) => {
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: Config.get('apiUrlBase') + service,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
        'Authorization-Token': localStorage.getItem('token'),
      },
      data: data,
    })
      .then((res) => {
        let name = res.headers['content-disposition'].split('=')[1]
        let data = {filename: name, data: res.data}
        return resolve(data)
      })
      .catch((err) => {
        handleError(err);
        reject(err);
      });
  });
};

export const sendDataBlob = (service, method, data) => {
  console.log(service, method, data);
  
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: Config.get('apiUrlBase') + service,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
        'Authorization-Token': localStorage.getItem('token'),
      },
      data: data,
    })
    .then((res) => resolve(res.data))
    .catch((err) => {
        handleError(err);
        reject(err);
      });
  });
};

// Se pasa un service o modulo como String. E.G.: "/moviles" "/moviles/2"
export const deleteData = (service) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'DELETE',
      url: Config.get('apiUrlBase') + service,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization-Token': localStorage.getItem('token'),
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => (err.response.data.codigo === 4000 ? reject(err) : handleError(err)));
  });
};

// Maneja los errores con un modal de sweet-alert;
const handleError = (err) => {
  return new Promise((resolve, reject) =>{
    let codigo = err.response && err.response.data ? err.response.data.codigo : null;
    let message = ""
    let detail = ""
    let status = err.response ? err.response.status : null;
    
    if(codigo === 4011 || codigo === 4010 || status === 401) {
      message = 'La sesión expiró.';
      detail = 'Por favor, ingrese nuevamente.';
    } else if(codigo === 4000) {
      message = err.response.data.mensaje;
      detail = err.response.data.detalle.toString();
    } else if(codigo === 4030) {
      message = 'No tiene permisos para realizar esta acción.';
      detail = 'Contacte al administrador.';
    } else if(codigo >= 5000) {
      message = 'Error interno del sistema.';
      detail = 'Contacte al administrador.';
    } else if(status === 403) {
      message = 'No tiene permisos para realizar esta acción.';
      detail = 'Contacte al administrador.';
    } else if(status === 404) {
      message = 'Recurso no encontrado.';
      detail = 'El recurso solicitado no existe.';
    } else if(!err.response) {
      message = 'Error de conexión.';
      detail = 'No se pudo comunicar con el servidor.';
    }
   
    if(codigo === 4011 || codigo === 4010 || status === 401) {
      swal({
        title: message,
        text: detail,
        icon: "error",
        buttons: {
          confirm: {
            text: 'Aceptar',
            value: true,
            visible: true,
            className: "btn btn-primary",
            closeModal: true
          }
        }
      }).then((isConfirmed) => {
        if (isConfirmed) {
          window.location.reload();
          resolve(message)
        }
      });
    }
    else{
      swal.fire(message, detail, 'error');
      resolve(message)
    }
  })

};

export const getDataNoErrorMessage = (service) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'GET',
      url: Config.get('apiUrlBase') + service,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization-Token': localStorage.getItem('token'),
      },
    })
      .then((res) => resolve(res.data))
      .catch((err) => {
          reject(err);
      });
  });
};

export const sendDataMultilanguage = (service, method, data, intl) => {
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: Config.get('apiUrlBase') + service,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization-Token': localStorage.getItem('token'),
      },
      data: data,
    })
      .then((res) => resolve(res.data))
      .catch((err) => {
        handleErrorMultilanguage(err, intl);
        reject(err);
      });
  });
};

const handleErrorMultilanguage = (err, intl) => {
  return new Promise((resolve, reject) =>{
    let codigo = err.response.data.codigo
    let message = ""
    let detail = ""
    
    if(codigo === 4011 || codigo === 4010 || err.response.status === 401) {
      message = 'La sesión expiró.';
      detail = 'Por favor, ingrese nuevamente.';
    } else if(codigo === 4000) {
      message = err.response.data.mensaje;
      detail = err.response.data.detalle.toString();
    } else if(codigo === 4030) {
      message = 'No tiene permisos para realizar esta acción.';
      detail = 'Contacte al administrador.';
    } else if(codigo >= 5000) {
      message = 'Error interno del sistema.';
      detail = 'Contacte al administrador.';
    }
  
    if(codigo === 4011 || codigo === 4010 || err.response.status === 401) {
      swal({
        title: message,
        text: detail,
        icon: "error",
        buttons: {
          confirm: {
            text: 'Aceptar',
            value: true,
            visible: true,
            className: "btn btn-primary",
            closeModal: true
          }
        }
      }).then((isConfirmed) => {
        if (isConfirmed) {
          window.location.reload();
          resolve(message)
        }
      });
    }
    else{
      swal.fire(message, intl.formatMessage({ ...(backendStrings[detail] ? backendStrings[detail] : backendStrings['errors.default'])}), 'error');
      resolve(message)
    }
  })

};

export const formatTiempoEnTaller = (segundos) => {
  if (segundos === null || segundos === undefined) return '—';
  var dias = Math.floor(segundos / 86400);
  var horas = Math.floor((segundos % 86400) / 3600);
  var minutos = Math.floor((segundos % 3600) / 60);
  var partes = [];
  if (dias > 0) partes.push(dias + (dias === 1 ? ' día' : ' días'));
  if (horas > 0) partes.push(horas + 'h');
  if (minutos > 0 || partes.length === 0) partes.push(minutos + 'm');
  return partes.join(' ');
};